import React from "react";
import { ArrowRight, LockKeyhole } from "lucide-react";
import { Button } from "./Button";
import { CHECKOUT_URL } from "../data/content";
type PurchaseCtaProps = {
  label?: string;
  supportText?: string;
  className?: string;
};
export function PurchaseCta({
  label = "💥 QUIERO MI ATLETISMO RESUELTO",
  supportText = "Pago 100% seguro · Mercado Pago | Tarjeta | Transferencia",
  className = ""
}: PurchaseCtaProps) {
  const goToCheckout = () => {
    window.location.href = CHECKOUT_URL;
  };
  return <div className={`flex flex-col items-center gap-3 ${className}`} data-id="element-165" data-mp="2va0xqjj9cp9t">
      <Button type="button" size="lg" onClick={goToCheckout} aria-label="Comprar Atletismo Resuelto Sistema Completo" className="group h-auto min-h-14 w-full rounded-xl border border-[#FFD66B]/35 bg-[#E3262E] px-5 py-4 text-center text-sm font-black tracking-wide text-white shadow-[0_12px_38px_rgba(227,38,46,0.3)] transition-[transform,background-color,box-shadow] duration-200 ease-out hover:-translate-y-0.5 hover:bg-[#C81724] hover:shadow-[0_16px_44px_rgba(227,38,46,0.4)] focus-visible:ring-[#FFD66B] sm:w-auto sm:min-w-[360px] sm:text-base" data-id="element-166" data-mp="2hk765tgdbqwe">
        {label}
        <ArrowRight className="ml-2 size-5 transition-transform duration-200 group-hover:translate-x-1" aria-hidden="true" data-id="element-167" data-mp="119530vs885c6" />
      </Button>
      <p className="flex items-center justify-center gap-2 text-center text-xs text-[#8E9AAA] sm:text-sm" data-id="element-168" data-mp="wgu6m2wp31od">
        <LockKeyhole className="size-3.5 text-[#27B36A]" aria-hidden="true" data-id="element-169" data-mp="1b95s6ycs1foa" />
        {supportText}
      </p>
    </div>;
}